<template >
  <div>
    <bar-example
      v-if="!myLoading"
      :key="uniqueId('bar-cro-2')"
      :bar-label="graph.label"
      :bar-data="graph.dataset"
      chartId="chart-doughnut-02"
      :height="isMobile"
    ></bar-example>
    <br /><br />
    <table
      v-if="!myLoading"
      class="table table-hover table-bordered table-striped table-sm"
    >
      <thead class="soft-grey">
        <tr class="text-center">
          <th rowspan="2" style="">Nama Konsumen</th>
          <th rowspan="2" style="">Order Number</th>
          <th rowspan="2" style="">Tanggal Order</th>
          <th rowspan="2" style="">Rencana Tanggal Kirim</th>
          <th colspan="4" style="border-bottom: 0px">TOTAL ORDER DETAIL</th>
        </tr>
        <tr class="text-center">
          <th>QTY</th>
          <th>TOTAL</th>
        </tr>
      </thead>

      <tbody v-if="data">
        <template v-for="(data, key) in data">
          <tr :key="uniqueId('history' + key)">
            <td colspan="6" class="green font-c-white">{{ key }}</td>
          </tr>
          <tr
            v-for="(val, index) in data"
            :key="uniqueId('detail' + index)"
            class="text-center"
          >
            <td class="text-left">&nbsp; &raquo;{{ val.customer_name }}</td>
            <td>
              <b-button
                class="btn btn-link"
                variant="excel icon"
                size="sm"
                v-on:click.prevent="openDetail(val.order_number)"
                >{{ val.order_number }}</b-button>
            </td>
            <td>{{ dateTimeFormat(val.date_order) }}</td>
            <td>{{ dateFormat(val.plan_delivery_order) }}</td>
            <td>{{ formatPrice(val.qty_plan) }}</td>
            <td>{{ formatPrice(val.total_price_plan) }}</td>
          </tr>
        </template>
      </tbody>
      <tbody v-else>
        <tr>
          <td :colspan="6" class="text-center">No data</td>
        </tr>
      </tbody>
    </table>
    <loading v-else></loading>

    <b-modal
      ref="myModalRef"
      id="showDetail"
      header-border-variant="no-border text-center"
      footer-border-variant="no-border"
      footer-bg-variant="light"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      hide-footer
      size="lg"
    >
      <div slot="modal-header" class="text-center">
        <h3 class="text-center">Detail Order {{ title_show_detail }}</h3>
      </div>

      <div v-if="!myLoading">
        <b-row>
          <b-col sm="12" >
            <global-table-only
              :table-data="detail_order"
              :loading="myLoading2"
              :per-page="10"
              :bordered="true"
              :hover="true"
              :striped="false"
              :fields="fields"
              :redirect-detail="false"
              :show-add-button="false"
              caption="<i class='fa fa-align-justify'></i> Asset Status Listing"
              addButton="Tambah Asset Status"

            ></global-table-only>
          </b-col>
        </b-row>

        <b-row>
          <b-col sm="12">
            <div class="float-right">
              <b-button
                type="button"
                size="sm"
                variant="danger"
                @click="closeDetail"
              >
                <i class="fa fa-undo"></i> Back
              </b-button>
            </div>
          </b-col>
        </b-row>
      </div>

      <div v-else>
        <loading></loading>
      </div>
    </b-modal>
  </div>
</template>


<script>
import globalTableOnly from "@/templates/TableOnly.vue";
import interfaces from "@/templates/_interfaces.js";
import * as moment from "moment";
import loading from "@/templates/Loading.vue";
import tableTotal from "@/templates/TableTotal.vue";
import BarExample from "@/views/charts/BarExample.vue";

import _ from "lodash";

export default {
  name: "history-customer",
  components: { globalTableOnly, loading, tableTotal, BarExample },
  props: {
    flag: {
      type: Number,
      default: 0,
    },
    month: {
      type: String,
      default: "",
    },
    year: {
      type: String,
      default: "",
    },
    employee: {
      type: String,
      default: "",
    },
    customerGroup: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      myCustomer: {},
      myLoading: false,
      myLoading2: false,
      graph: {},
      data: [],
      title_show_detail: '',
      detail_order: [],
      fields: [
        { key: "customer_name", label: "Nama Konsumen", sortable: true },
        { key: "order_number", label: "Order Number", sortable: true },
        { key: "product_name", label: "Nama Product", sortable: true },
        { key: "qty_plan", label: "Qty Plan", sortable: true },
        { key: "price_plan", label: "Price Plan", sortable: true },
        { key: "total_price_plan", label: "Total Price Plan", sortable: true },
      ],
    };
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  computed: {
    isMobile: function () {
      let check = false;
      (function (a) {
        if (
          /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
            a
          ) ||
          /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
            a.substr(0, 4)
          )
        )
          check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      if (check === true) {
        if (window.screen.width < 732) {
          return undefined;
        } else {
          return 100;
        }
      } else {
        return 75;
      }
    },
  },
  methods: {
    uniqueId: function (param = "") {
      return _.uniqueId(param);
    },
    init: function () {
      this.myLoading = true;
      const monthYear = this.year + "-" + this.month;
      this.axios
        .get(
          "web/dashboard/customer_history/schedule/" +
            this.flag +
            "/" +
            monthYear +
            "/" +
            this.employee +
            "/" +
            this.customerGroup
        )
        .then((response) => {
          this.graph = response.data.graph;
          this.data = response.data.data_table;
          let temp2 = [];
          temp2.push(this.graph.dataset);
          this.graph.dataset = temp2;
          //   this.customer_status = response.data.customer_status;
          //   this.customer_group = response.data.customer_group;
          //   this.customer_gt_nongt = response.data.customer_gt_nongt;
          //   this.customer_no_route = response.data.customer_no_route;
          //   this.customer_no_order = response.data.customer_no_order;
          //   this.customer_in_dc = response.data.customer_in_dc;
          //   this.customer_expired_freezer = response.data.customer_expired_freezer;
        })
        .catch((error) => {
          this.expired(error);
        })
        .finally(() => {
          this.myLoading = false;
        });
    },
    expired: function (error, title) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired",
        });
      } else {
        this.showErrorNotification({
          title: title,
          message: error.response.data.message,
        });
      }
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(0).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    dateFormat: function (date) {
      return date === null ? "" : moment(date).format("DD MMM YYYY");
    },
    dateTimeFormat: function (date) {
      return moment(date).format("DD MMM YYYY HH:mm:ss");
    },
    openDetail: function(order_number) {
      this.title_show_detail = order_number;
      this.$refs.myModalRef.show();
      this.myLoading2 = true;

      this.axios
        .get("web/dashboard/customer_history/order/detail/" +order_number )
        .then((response) => {
          this.detail_order = response.data.data;
        })
        .catch((error) => {
          this.expired(error);
        })
        .finally(() => {
          this.myLoading2 = false;
        });
    },
    closeDetail: function() {
      this.title_show_detail = '';
      this.data_detail = [];
      this.$refs.myModalRef.hide();
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style>
</style>
